<template>
<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg165"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs169"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath179"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path177" /></clipPath></defs><g
     id="g171"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g173"><g
         id="g175"
         clip-path="url(#clipPath179)"><g
           id="g181"
           transform="translate(380.6318,383.9102)"><path
             d="m 0,0 v -155.704 m -24.309,-24.32 h -184.252 c -13.388,0 -24.336,10.941 -24.336,24.32 V 0 M 0,-155.704 c 0,-13.379 -10.949,-24.32 -24.309,-24.32"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path183" /></g><g
           id="g185"
           transform="translate(347.7578,443.0112)"><path
             d="M 0,0 C 27.569,32.825 -25.642,85.208 -53.948,43.596 L -83.561,0"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path187" /></g><g
           id="g189"
           transform="translate(180.6084,443.0112)"><path
             d="M 0,0 C -27.57,32.825 25.669,85.208 53.948,43.596 L 83.589,0"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path191" /></g><g
           id="g193"
           transform="translate(40.2065,147.7324)"><path
             d="m 0,0 h 40.362 c 9.19,0 16.706,-7.512 16.706,-16.696 v -93.626 c 0,-9.184 -7.516,-16.696 -16.706,-16.696 H 0 c -9.19,0 -16.707,7.512 -16.707,16.696 v 93.626 C -16.707,-7.512 -9.19,0 0,0 Z"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path195" /></g><g
           id="g197"
           transform="translate(293.4971,103.3994)"><path
             d="m 0,0 99.586,49.322 c 12.963,6.406 28.592,3.741 36.193,-8.56 7.63,-12.303 3.234,-27.808 -8.538,-36.17 L 10.098,-78.773 c -34.916,-23.272 -49.666,-14.144 -86.397,-4.195 -24.932,7.342 -31.881,9.325 -56.813,16.667 -27.485,8.079 -38.518,8.617 -63.11,8.617 m 106.11,55.53 56.331,-16.327 C -19.4,-22.648 -4.197,-14.371 0,0 4.198,14.372 -4.141,29.508 -18.493,33.76 l -39.398,11.678 c -32.987,9.808 -64.471,12.529 -95.19,-5.187 -10.977,-6.293 -16.082,-12.614 -35.625,-12.614 h -7.516"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path199" /></g><g
           id="g201"
           transform="translate(172.8652,383.9102)"><path
             d="M 0,0 H -29.244 C -41.61,0 -51.708,10.12 -51.708,22.45 v 14.201 c 0,12.359 10.098,22.45 22.464,22.45 h 241.151 c 12.339,0 22.465,-10.091 22.465,-22.45 V 22.45 C 234.372,10.12 224.246,0 211.907,0 H 91.332"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path203" /></g><g
           id="g205"
           transform="translate(264.1973,250.231)"><path
             d="m 0,0 -41.412,39.939 c -11.402,11.792 -11.402,31.067 0,42.859 9.928,10.29 26.379,8.93 36.789,-0.793 4.765,-4.451 4.481,-4.451 9.218,0 10.41,9.723 26.861,11.083 36.816,0.793 11.374,-11.792 11.374,-31.067 0,-42.859 z"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path207" /></g><g
           id="g209"
           transform="translate(39.8662,295.1875)"><path
             d="M 0,0 H 54.09"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path211" /></g><g
           id="g213"
           transform="translate(93.9849,338.7271)"><path
             d="M 0,0 -46.915,22.903"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path215" /></g><g
           id="g217"
           transform="translate(93.9849,251.6484)"><path
             d="M 0,0 -46.915,-22.903"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path219" /></g><g
           id="g221"
           transform="translate(488.5,295.1875)"><path
             d="M 0,0 H -54.09"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path223" /></g><g
           id="g225"
           transform="translate(434.4102,338.7271)"><path
             d="M 0,0 46.886,22.903"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path227" /></g><g
           id="g229"
           transform="translate(434.4102,251.6484)"><path
             d="M 0,0 46.886,-22.903"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path231" /></g><g
           id="g233"
           transform="translate(217.7651,383.9102)"><path
             d="M 0,0 H 0.028"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path235" /></g></g></g></g></svg>
</template>
